module.exports = __webpack_public_path__ + "static/media/event14.9707ae40.jpeg";